import type { Theme } from "@repo/tokens";

export function getSubjectiveAnswerBoxColors(
  theme: Theme,
  isAttempted: boolean,
) {
  return isAttempted
    ? {
        borderColor: theme.colors.neutral[60],
        backgroundColor: theme.colors.neutral[90],
      }
    : {
        borderColor: theme.colors.neutral[60],
        backgroundColor: theme.colors.neutral[100],
      };
}
